// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"393":"36f975fc","3824":"866e3108","7501":"32f45da8"}[chunkId] + ".chunk.css";
};